import config from 'Cloud/config';
import classNames from 'clsx';
import React, { memo, ReactElement, useCallback } from 'react';
import styles from 'reactApp/ui/Breadcrumbs/Breadcrumb.css';
import { BreadcrumbItem } from 'reactApp/ui/Breadcrumbs/Breadcrumbs.types';
import { DataListControl } from 'reactApp/ui/DataListControl/DataListControl';
import { Hint } from 'reactApp/ui/Hint/Hint';
import { Link } from 'reactApp/ui/Link/Link';
import { getTrimmedText } from 'reactApp/utils/textHelpers';

import { sendGa } from '../TariffsSection/TariffsSection.helpers';

const IS_PUBLIC = config.get('PUBLIC');
const IS_PUBLIC_SHOVE = config.get('PUBLIC_SHOVE');

export const Breadcrumb = memo(
    ({
        breadcrumb,
        onClick,
        isActive,
        onShareClick,
        onPublishClick,
    }: {
        breadcrumb: BreadcrumbItem;
        isActive: boolean;
        onClick: (e: React.MouseEvent, breadcrumb: BreadcrumbItem) => void;
        onShareClick: (e: React.MouseEvent, breadcrumb: BreadcrumbItem) => void;
        onPublishClick: (e: React.MouseEvent, breadcrumb: BreadcrumbItem) => void;
    }): ReactElement => {
        const handleGoTo = useCallback(
            (e): void => {
                if (!isActive) {
                    sendGa('breadcrumbs', 'click');
                    onClick(e, breadcrumb);
                }
            },
            [breadcrumb.id, isActive, onClick]
        );

        const handleClick = useCallback((): void => {
            if (!isActive) {
                sendGa('breadcrumbs', 'click');
            }
        }, [breadcrumb.id, isActive, sendGa]);

        const handleOnPublishClick = useCallback(
            (e) => {
                onPublishClick(e, breadcrumb);
            },
            [breadcrumb.id, onPublishClick]
        );
        const handleOnShareClick = useCallback(
            (e) => {
                onShareClick(e, breadcrumb);
            },
            [breadcrumb.id, onShareClick]
        );

        const renderControls = (breadcrumb.showShare || breadcrumb.showWeblink) && isActive;

        let lengthStringBreadcrumbs = 27;
        if (IS_PUBLIC_SHOVE) {
            lengthStringBreadcrumbs = 22;
        } else if (IS_PUBLIC) {
            lengthStringBreadcrumbs = 33;
        }

        return (
            <Link id={breadcrumb.id} storage={breadcrumb.storage} handleGoTo={handleGoTo} handleClick={handleClick}>
                <div className={classNames(styles.root, { [styles.root_active]: isActive })}>
                    <Hint text={breadcrumb.text}>
                        <div className={styles.text}>{getTrimmedText(breadcrumb.text, lengthStringBreadcrumbs)}</div>
                    </Hint>
                    {renderControls && (
                        <div className={styles.controls}>
                            {breadcrumb.showWeblink && (
                                <Hint text="Поделиться">
                                    <div className={styles.control}>
                                        <DataListControl
                                            size={28}
                                            type="publish"
                                            active={!!breadcrumb.weblink}
                                            onClick={handleOnPublishClick}
                                        />
                                    </div>
                                </Hint>
                            )}
                            {breadcrumb.showShare && (
                                <Hint text="Настроить доступ">
                                    <div className={styles.control}>
                                        <DataListControl
                                            size={28}
                                            type="share"
                                            active={breadcrumb.kind === 'shared'}
                                            onClick={handleOnShareClick}
                                        />
                                    </div>
                                </Hint>
                            )}
                        </div>
                    )}
                </div>
            </Link>
        );
    }
);
Breadcrumb.displayName = 'Breadcrumb';
